import { UIState, UIAction } from './types'

export const initialUIState: UIState = {
  isShareModalOpen: false,
  isEditModalOpen: false,
}

export function uiReducer(state: UIState, action: UIAction): UIState {
  switch (action.type) {
    case 'TOGGLE_SHARE_MODAL':
      return { ...state, isShareModalOpen: !state.isShareModalOpen }
    case 'TOGGLE_EDIT_MODAL':
      return { ...state, isEditModalOpen: !state.isEditModalOpen }
    default:
      return state
  }
}
